const yup = require("yup");

// Schema for createcollegerules
const create = yup.object({
  page: yup.string().required("Page is required"),
  group: yup.string().required("Group is required"),
});

module.exports = {
  create,
};
